import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IRouterProps } from '@interfaces/App.interface';
import { IConfigComponent } from '@ts/ui-models';
import { generateGlobalColumns, generateBasicColumn, TInheritedProps, IDataGridConfig } from '@ts/storybook';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';

interface ILicenseTypesProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
}

export const defaultConfigComponent: IConfigComponent = generateConfigComponent('licenseType');

const LicenseTypes = (props: ILicenseTypesProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };
  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [globalCells.id(), globalCells.name(), generateBasicColumn({ field: 'valueType' }, { field: 'valueType' })];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      inheritedProps={inheritedProps}
    />
  );
};

export default LicenseTypes;
